import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { IHolder, ITransaction } from "../interfaces";
import { toast } from "react-toastify";
import Axios, { AxiosResponse } from "axios";
import config from "../config";
import { arrayToFormData, normalize } from "../utils/functions";
import CoreComponent from "./CoreComponent";
import { t } from "i18next";
import { connect } from "react-redux";
import TransactionModal from "../components/TransactionModal";

interface IState {
    transactions: ITransaction[],
    limit: number,
    pagination: any,
    query: string,
    ids: number[],
    type: string,
    sort: string,
    isLoading: boolean,
    isOpen: boolean,
    currentPage: number,
    holder: IHolder,
    transaction: ITransaction
}

class Transactions extends CoreComponent<any, any> {
    state: IState = {
        transactions: [],
        limit: 30,
        pagination: null,
        query: "",
        ids: [],
        type: "",
        sort: "",
        isLoading: true,
        isOpen: false,
        currentPage: 1,
        holder: null,
        transaction: null
    }

    constructor(props: any) {
        super(props);

        this.handleModal = this.handleModal.bind(this);
    }

    async componentWillMount() {
        this.loadObjects();
    }

    async loadObjects() {
        this.setState({
            isLoading: true,
        }, async () => {
            let url = null;
            let limit = this.state.limit * this.state.currentPage;

            url = `${config.api}/transactions?limit=${limit}&user_id=${this.props.match.params.id}`;

            if (this.state.sort) {
                url += `&sort=${this.state.sort}`;
            }

            if (this.state.type) {
                url += `&type=${this.state.type}`;
            }

            let res = await Axios.get(url);

            if (!this.isUnmounted) {
                this.setState({
                    transactions: res.data.models,
                    pagination: res.data.pagination,
                    holder: res.data.user,
                    isLoading: false
                })
            }
        })
    }

    setOrder(sort: string) {
        this.setState({
            type: this.state.sort != sort ? "asc" : (this.state.type == "asc" ? "desc" : "asc"),
            sort
        }, () => {
            this.loadObjects();
        });
    }

    showMore() {
        this.setState({
            currentPage: this.state.currentPage + 1
        });
    }

    async delete() {
        if (confirm("Вы уверены?")) {
            if (this.state.ids.length > 0) {
                let response: AxiosResponse = await Axios.post(`${config.api}/transactions/delete`, arrayToFormData({ id: this.state.ids, user_id: this.props.match.params.id }));

                if (response.data && response.data.deleted.length > 0)
                    this.setState({
                        transactions: this.state.transactions.filter((object: ITransaction) => !response.data.deleted.includes(object.id.toString())),
                        ids: [],
                        holder: response.data.user
                    });

                toast("Транзакции удалены: " + response.data.deleted.length, { type: "success" });
            } else {
                toast("Выберите транзакций", { type: "error" });
            }
        }
    }

    handleModal() {
        this.setState({
            isOpen: !this.state.isOpen
        }, () => {
            this.loadObjects();
        });
    }

    render() {
        let { t, auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div>
                <TransactionModal isOpen={this.state.isOpen} handleModal={this.handleModal} user_id={this.props.match.params.id} transaction={this.state.transaction} />

                <div className="crm-holders">
                    <div className="wrapper">
                        <NavLink className="crm-holders__back" to={"/admin/holder/" + this.props.match.params.id}>
                            Назад
                        </NavLink>
                        <span className="crm-holders__title">
                            Партнер <div className="block-line"></div> {this.state.holder?.full_name}{" "}
                            <div className="block-line"></div> Транзакции
                        </span>
                        <div className="crm-holders__headline">
                            <div className="crm-holders__buttons">
                                <a className="crm-button" role="button" onClick={() => this.handleModal()}>
                                    Добавить
                                </a>
                                <a className="crm-button" role="button" onClick={() => this.delete()}>
                                    Удалить
                                </a>
                            </div>
                            <div className="crm-holders__count">
                                <img src="img/Group 205.svg" alt="" />
                                <select
                                    id="select_page"
                                    style={{ width: "70px" }}
                                    className="numm"
                                    value={this.state.limit}
                                    onChange={(e: any) => {
                                        this.setState({
                                            limit: Number.parseInt(e.target.value)
                                        })
                                    }}
                                >
                                    <option value="15">15</option>
                                    <option value="30">30</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="500">500</option>
                                    <option value="100000">Все</option>
                                </select>
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                {this.state.holder && <a className="btn-del mr-4 px-3" role="button" style={{ width: "unset", height: '23px' }} onClick={async () => {
                                    if (confirm("Вы уверены?")) {
                                        let res = await Axios.post(`${config.api}/artist/block-payment`, arrayToFormData({ id: this.state.holder.id }));

                                        this.setState({
                                            holder: {
                                                ...this.state.holder,
                                                payment_blocked: res.data.status == "blocked" ? 1 : 0
                                            }
                                        })
                                    }
                                }}>
                                    {this.state.holder.payment_blocked == 0 ? <><i className="fa fa-lock mr-2"></i> Приостановить платеж </> : <><i className="fa fa-unlock mr-2"></i> Возобновить платеж </>}
                                </a>}
                                <span
                                    style={{ display: "block", marginRight: "15px" }}
                                    className="text-red"
                                >
                                    Баланс:
                                </span>
                                <span className={Number.parseFloat(this.state.holder?.balance) >= 0 ? "text-green" : "text-red"}>${this.state.holder ? Number.parseFloat(this.state.holder.balance).toFixed(3).slice(0, -1) : ""}</span>
                            </div>
                        </div>

                        <div className="crm-list mb-4">
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            <input type="checkbox" onChange={() => {
                                                if (this.state.ids.length != this.state.transactions.length) {

                                                    this.setState({
                                                        ids: this.state.transactions.map((holder: ITransaction) => holder.id)
                                                    });

                                                } else {
                                                    this.setState({
                                                        ids: []
                                                    })
                                                }
                                            }} checked={this.state.ids.length == this.state.transactions.length} />
                                        </th>
                                        <th>
                                            <a role="button" onClick={() => {
                                                this.setOrder("payment_date");
                                            }}>
                                                Дата
                                            <img src="img/Group 199.svg" alt="" />
                                            </a>
                                        </th>
                                        <th>
                                            <a role="button" onClick={() => {
                                                this.setOrder("currency");
                                            }}>
                                                Сумма
                                            <img src="img/Group 199.svg" alt="" />
                                            </a>
                                        </th>
                                        <th>
                                            <a role="button" onClick={() => {
                                                this.setOrder("type");
                                            }}>
                                                Источник/Назначение
                                            <img src="img/Group 199.svg" alt="" />
                                            </a>
                                        </th>
                                        <th>
                                            <a role="button" onClick={() => {
                                                this.setOrder("place");
                                            }}>
                                                Описание
                                            <img src="img/Group 199.svg" alt="" />
                                            </a>
                                        </th>
                                        {/* <th>
                                            <a role="button" onClick={() => {
                                                this.setOrder("comment");
                                            }}>
                                                Комментарий
                                            <img src="img/Group 199.svg" alt="" />
                                            </a>
                                        </th> */}
                                        <th>
                                            <a role="button" onClick={() => {
                                                this.setOrder("name");
                                            }}>
                                                Способ оплаты
                                                <img src="img/Group 199.svg" alt="" />
                                            </a>
                                        </th>
                                        <th>
                                            Баланс
                                        </th>
                                        {/* <th>
                                            <a role="button" onClick={() => {
                                                this.setOrder("status");
                                            }}>
                                                Статус <img src="img/Group 199.svg" alt="" />
                                            </a>
                                        </th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {!this.state.isLoading && this.state.transactions.length == 0 && <tr><td colSpan={11}>{t("Ничего не найдено")}</td></tr>}
                                    {this.state.isLoading && <tr><td colSpan={11}>{t("Загрузка данных")}</td></tr>}
                                    {this.state.transactions.filter((object: ITransaction, i: number) => i <= this.state.limit * this.state.currentPage).map((object: ITransaction, i: number) => {
                                        return <tr key={i}>
                                            <td>
                                                <input type="checkbox" checked={!!this.state.ids.find((id: number) => id == object.id)} onChange={(e: any) => {
                                                    if (e.target.checked) {
                                                        this.setState({
                                                            ids: [...this.state.ids, object.id]
                                                        });
                                                    } else {
                                                        this.setState({
                                                            ids: this.state.ids.filter((id: number) => id != object.id)
                                                        });
                                                    }
                                                }} />
                                            </td>
                                            <td>
                                                <div className="d-flex justify-content-center">
                                                    {object.date}
                                                    {object.type != 0 && <a role="button" onClick={() => {
                                                        this.setState({
                                                            transaction: { ...object },
                                                            isOpen: true
                                                        });
                                                    }}>
                                                        <img src="/img/Icon awesome-edit.svg" style={{ width: "14px", marginLeft: "5px" }} />
                                                    </a>}
                                                </div>
                                            </td>
                                            <td className={object.type != 2 ? "text-green" : "text-red"}>$ {(object.type != 2 ? "+" : "-") + (Number.parseFloat(object.currency.toString()).toFixed(3).slice(0, -1))}</td>
                                            <td>{object.type == 2 ? object.typeName : object.place}</td>
                                            <td title={object.comment}>{normalize(object.comment)}</td>
                                            <td>{object.name}</td>
                                            <td className={Number.parseFloat(object.balance.toString()) >= 0 ? "text-green" : "text-red"}>${Number.parseFloat(object.balance.toString()).toFixed(3).slice(0, -1)}</td>
                                        </tr>;
                                    })}
                                </tbody>

                            </table>
                            <div className="text-center p-3">
                                {this.state.transactions.length > 0 && this.state.currentPage * this.state.limit < (this.state.transactions.length) && <a role="button" className="spec-color fs-12" onClick={() => {
                                    this.showMore();
                                }}>Показать ещё...</a>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth
    };
})(withTranslation()(Transactions));